import { createInput } from '@formkit/vue'
import LRating from '@ui/components/LRating'

export const rating = createInput(LRating, {
  props: ['stars', 'cancel', 'onIcon', 'offIcon', 'cancelIcon'],
})
